/* eslint-disable prefer-template */
document.addEventListener('DOMContentLoaded', () => {
	const timer = document.querySelector('.timer')
	const deadline = timer?.getAttribute('data-deadline')

	if (!timer) {
		return
	}

	function updateCountdown() {
		const endTime = new Date(deadline).getTime()
		const now = new Date().getTime()
		const timeLeft = endTime - now

		const timeZoneOffset = new Date().getTimezoneOffset() * 60000
		const adjustedTimeLeft = timeLeft + timeZoneOffset + 0 * 60 * 60 * 1000

		const days = Math.floor(adjustedTimeLeft / (1000 * 60 * 60 * 24))
		const hours = Math.floor((adjustedTimeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
		const minutes = Math.floor((adjustedTimeLeft % (1000 * 60 * 60)) / (1000 * 60))
		const seconds = Math.floor((adjustedTimeLeft % (1000 * 60)) / 1000)

		timer.querySelector('.day').innerText = days < 10 ? '0' + days : days
		timer.querySelector('.hours').innerText = hours < 10 ? '0' + hours : hours
		timer.querySelector('.min').innerText = minutes < 10 ? '0' + minutes : minutes
		timer.querySelector('.sec').innerText = seconds < 10 ? '0' + seconds : seconds
	}

	const interval = setInterval(updateCountdown, 1000)
})
